import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ReviewCyclesCreate, ReviewCyclesDelete, ReviewCyclesRefresh, ReviewCyclesUpdate, ReviewsCyclesRefreshById } from './review-cycles.action';
import { ReviewsService } from '../../reviews.service';
import { ReviewCycle } from '../../reviews.models';

export class ReviewCyclesStateModel {
  data: ReviewCycle[] = [];
  // Distinguish an empty response from the store's pre-request default.
  loaded: boolean = false;
}

@State<ReviewCyclesStateModel>({
  name: 'ReviewCycles',
  defaults: {
    data: [],
    loaded: false,
  }
})
@Injectable()
export class ReviewCyclesState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ReviewsService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ReviewCyclesStateModel) {
    return state.data;
  }

  @Action(ReviewCyclesRefresh)
  refresh({ patchState }: StateContext<ReviewCyclesStateModel>) {
    patchState({ loaded: false });
    this._service.getReviewCycles().subscribe(
      data => patchState({ data, loaded: true }),
      error => console.error(error)
    );
  }

  @Action(ReviewsCyclesRefreshById)
  refreshById({ getState, patchState }: StateContext<ReviewCyclesStateModel>, { id }: ReviewsCyclesRefreshById) {
    this._service.getReviewCycleById(id).subscribe(item => {
      const state = getState();
      const index = state.data.map(x => x.id).indexOf(id);
      if (index >= 0) {
        state.data.splice(index, 1);
      }
      patchState({
        data: [...state.data, item]
      });
    },
      error => console.error(error)
    );
  }

  @Action(ReviewCyclesCreate)
  create({ getState, patchState }: StateContext<ReviewCyclesStateModel>, { item }: ReviewCyclesCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(ReviewCyclesUpdate)
  update({ getState, patchState }: StateContext<ReviewCyclesStateModel>, { id, item }: ReviewCyclesUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(ReviewCyclesDelete)
  delete({ getState, patchState }: StateContext<ReviewCyclesStateModel>, { id }: ReviewCyclesDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
